/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const SpaceSize = core.serialization.object({
    name: core.serialization.string(),
    id: core.serialization.string(),
    numUsers: core.serialization.number(),
    pdv: core.serialization.number(),
    numFiles: core.serialization.number(),
});
